import { FunctionComponent, PropsWithChildren } from "react";
import styled from "styled-components";
import Header from "../Header";
import { NotificationContainer } from "react-notifications";
import GlobalStyle from "theme/GlobalStyle";

type OwnProps = {};
type Props = PropsWithChildren<OwnProps>;

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  > main {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
`;

const Layout: FunctionComponent<Props> = ({ children }) => {
  return (
    <StyledLayout>
      <GlobalStyle />
      <NotificationContainer />
      <Header />
      <main>{children}</main>
    </StyledLayout>
  );
};

export default Layout;
